import OpalAccordionCardV1 from "../OpalAccordionCardV1/OpalAccordionCardV1";
import OpalAccordionCardV2 from "../OpalAccordionCardV2/OpalAccordionCardV2";
import OpalAccordionCardV3 from "../OpalAccordionCardV3/OpalAccordionCardV3";
import OpalAccordionCardV4 from "../OpalAccordionCardV4/OpalAccordionCardV4";
import OpalAccordionCardV5 from "../OpalAccordionCardV5/OpalAccordionCardV5";
import OpalAccordionCardV6 from "../OpalAccordionCardV6/OpalAccordionCardV6";

const OpalCardFactory = (type, props) => {
  switch (type) {
    case 'v1':
      return <OpalAccordionCardV1 {...props} />;
    case 'v2':
      return <OpalAccordionCardV2 {...props} />;
    case 'v3':
      return <OpalAccordionCardV3 {...props} />;
    case 'v4':
      return <OpalAccordionCardV4 {...props} />;
    case 'v5':
      return <OpalAccordionCardV5 {...props} />;
    case 'v6':
      return <OpalAccordionCardV6 {...props} />;
    default:
      return <OpalAccordionCardV1 {...props} />;
  }
};

export default OpalCardFactory;
